module.exports = __webpack_public_path__ + "static/logo-89f1df9a6ccd40db165f04813c0aa56e.png";